import ProviderOrdersLayout from "./ProviderOrdersLayout";

export default function ProviderOrdersCalendar() {
  return (
    <ProviderOrdersLayout>
      <div className="opacity-60 text-center py-10">
        <h2 className="text-xl font-bold mb-2">Calendrier des réservations</h2>
        <p>Disponible bientôt.</p>
      </div>
    </ProviderOrdersLayout>
  );
}
